import React from 'react';
import { IconSauceLogo } from '@saucelabs/ds-icons';

import Styles from './SauceLogo.styles';

const SauceLogo = () => (
  <h1 className={Styles.logo}>
    <a
      href="https://saucelabs.com/"
      title="Sauce Labs"
    >
      <IconSauceLogo />
    </a>
  </h1>
);

export default SauceLogo;
